
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { useRouter } from "next/router";
import SearchSection from "components/sections/SearchSection";
import Layout from "components/layout/layout";
import { useKeepAliveMountEffect, useKeepAliveUnmountEffect, withKeepAlive } from "react-next-keep-alive";
import { useEffect, useState } from "react";
const Search = () => {
    const router = useRouter();
    const [mounted, setMounted] = useState(true);
    useKeepAliveMountEffect('search', () => {
        setMounted(true);
    });
    useKeepAliveUnmountEffect('search', () => {
        setMounted(false);
    });
    return (<>
            <SearchSection isOpen={mounted} setIsOpen={() => {
        }}/>
        </>);
};
const WrappedSearch = (props) => {
    return (<Layout topBar={<div />} isNavBarHidden>
            <Search {...props}/>
        </Layout>);
};
const __Next_Translate__Page__1966fcd7af5__ = withKeepAlive(WrappedSearch, 'search');

    export default __appWithI18n(__Next_Translate__Page__1966fcd7af5__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  